module.exports = __webpack_public_path__ + "static/img/job.87541c7e.svg";